<template>
  <v-snackbar
      v-if="confirm_request"
      v-model="confirm_request.dialog"
      text
      :color="confirm_request.type"
      transition="scale-transition"
      centered
      :timeout="confirm_request.timeout"
      elevation="10"
      :multi-line="true"
      min-width="800"
      max-width="800"
  >
    <v-row>
      <v-icon v-if="confirm_request.type === 'error'" :color="confirm_request.type" large>mdi-alert-circle</v-icon>
      <v-icon v-if="confirm_request.type === 'warning'" :color="confirm_request.type" large>mdi-alert-circle-outline
      </v-icon>
      <v-icon v-if="confirm_request.type === 'info'" :color="confirm_request.type" large>mdi-information-outline
      </v-icon>
    </v-row>
    <v-row class="px-5 py-5">
      <v-card height="500" :width="800 - 45" class="overflow-y-auto" color="red lighten-5">
        <v-list-item
            v-for="(message, i) in confirm_request.message" :key="i">
          <v-list-item-content>
            <v-list-item-title v-text="message" class="text-wrap"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
          color="grey darken-1"
          text
          @click="confirm_request.dialog = false"
      >
        Cancel
      </v-btn>
      <v-btn
          v-if="confirm_request.type === 'warning'"
          text
          @click="onAgree"
      >
        OK
      </v-btn>
    </v-row>
  </v-snackbar>
</template>

<script>

let self = '';
export default {
  name: 'ConfirmDialog',

  props: {
    confirm_request: {default: {}},
    fetchRequest: {default: null},
  },

  computed: {},

  methods: {
    onAgree() {
      this.confirm_request.request['dto']['confirm'] = true
      this.fetchRequest()
      this.confirm_request.dialog = false
    },

  },

  mounted() {
  },

  created() {
  },

  data() {
    return {}
  },
}

</script>


<style scoped lang="scss">
</style>